import { render } from "./LocalShow.vue?vue&type=template&id=2da52a3c"
import script from "./LocalShow.vue?vue&type=script&lang=js"
export * from "./LocalShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__